// extracted by mini-css-extract-plugin
module.exports = {"header":"_taiwan_header__9743h","footer":"_taiwan_footer__2y3ri"};